'use client';

import { useMemo, useRef } from 'react';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import { CatIconChevronLeft } from '@blocks-react/components/Icons/ChevronLeft';
import { CarouselProps } from '../../service-recommendation/types';
import styles from './Carousel.module.scss';

export const Carousel = ({
  setcurrentPage,
  children,
  cardPerPage,
  currentPage,
  totalCard,
  buttonTranslation,
  desktopView
}: CarouselProps) => {
  const prevButtonRef = useRef<HTMLButtonElement>(null);
  const nextButtonRef = useRef<HTMLButtonElement>(null);
  const showArrows = useMemo(() => {
    return totalCard > 3 && desktopView;
  }, [desktopView, totalCard]);

  const handleNext = () => {
    setcurrentPage(currentPage + cardPerPage);
    setTimeout(() => {
      prevButtonRef?.current?.focus();
    }, 100);
  };

  const handlePrevious = () => {
    setcurrentPage(currentPage - cardPerPage);
    setTimeout(() => {
      nextButtonRef?.current?.focus();
    }, 100);
  };

  return (
    <>
      {showArrows && (
        <button
          className={`${styles['carousel-button']} ${styles['carousel-previous']}`}
          onClick={handlePrevious}
          disabled={currentPage === 0}
          data-testid="carousel-previous"
          aria-label={buttonTranslation.previous}
          ref={prevButtonRef}
          id="carousel-previous-button"
        >
          <CatIconChevronLeft slot="before" />
        </button>
      )}
      <div
        className={`${styles['carousel-container']}`}
        data-testid="carousel-container"
      >
        {children}
      </div>
      {showArrows && (
        <button
          className={`${styles['carousel-button']} ${styles['carousel-next']}`}
          data-testid="carousel-next"
          onClick={handleNext}
          disabled={currentPage >= totalCard - cardPerPage}
          aria-label={buttonTranslation.next}
          id="carousel-next-button"
          ref={nextButtonRef}
        >
          <CatIconChevronRight />
        </button>
      )}
    </>
  );
};
